import { PropTypes } from 'prop-types'

const ip = ({ text, children, containerClass, textClass }) => {

    return <div className={`tooltip ${containerClass}`}>
        <div className={`tooltip-text ${textClass}`}>{text}</div>
        {children}
    </div>
}

ip.propTypes = {
    text: PropTypes.any,
    location: PropTypes.string,
    containerClass: PropTypes.string,
    textClass: PropTypes.string,
    children: PropTypes.node
}

export default ip
